import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useToken } from '@chakra-ui/react';
import { Box } from '@hub/box';
import React from 'react';
import { CoreContainer } from '@hub/core-container';
import { Spotlight, SpotlightCard } from '../index';
import { AnalyticsImpressionTracker } from '../../../analytics-observer';
import { trackClickEvent } from './analytics';
import { jsx as _jsx } from "react/jsx-runtime";
const ROW_GAP = ['spacing-md', 'spacing-lg', 'spacing-lg'];
const COLUMN_GAP = ['spacing-sm', 'spacing-md', 'spacing-md'];
const SpotlightModule = _ref => {
  let {
    moduleProps,
    clickEvent
  } = _ref;
  const spaceBaseColumnGap = useToken('space', COLUMN_GAP[0]);
  return /*#__PURE__*/_jsx(CoreContainer, {
    "data-id": "spotlight-module_index_SpotlightModule_CoreContainer",
    children: /*#__PURE__*/_jsx(Spotlight, {
      heading: moduleProps.title,
      shortDescription: moduleProps.shortDescription,
      callToAction: moduleProps.callToAction,
      entries: moduleProps.entries,
      "data-id": "spotlight-module_index_SpotlightModule_CoreContainer_Spotlight",
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          rowGap: ROW_GAP,
          columnGap: COLUMN_GAP,
          justifyContent: 'center',
          alignContent: 'center',
          flexWrap: 'wrap'
        },
        "data-id": "spotlight-module_index_SpotlightModule_Spotlight_Box",
        children: (moduleProps.entries || []).map((entry, index) => /*#__PURE__*/_jsx(AnalyticsImpressionTracker, _objectSpread(_objectSpread({
          sx: {
            flex: [// Support a two column flexible layout with dynamic card width and height
            "0 1 calc(50% - ".concat(spaceBaseColumnGap, " / 2)"),
            // Support a flexible layout with fixed card dimensions
            '0 0 168px'],
            // We currently have no breakpoints configured for our minimum supported screen-size
            // of 320px. While Chakra does support configuring custom breakpoints, adding a new breakpoint
            // would break existing usages of Chakra's responsive array syntax thus requiring a chunky refactor.
            '@media screen and (max-width: 20rem)': {
              // Support a flexible single card layout with dynamic width and height
              flex: '1 1 100%'
            }
          },
          child: SpotlightCard,
          onCreateImpressionWhenView: entry.viewItem
        }, entry), {}, {
          onClick: () => {
            if (clickEvent) {
              clickEvent(index);
            }
            trackClickEvent(entry.title, moduleProps.heading || moduleProps.title);
          },
          "data-id": "spotlight-module_index_SpotlightModule_AnalyticsImpressionTracker"
        }), entry.title))
      })
    })
  });
};
export default SpotlightModule;